<template>
    <Button
        :label="getLabel"
        :icon="iconName"
        iconPos="right"
        :loading="loading"
        :class="classes"
        :disabled="disabled"
    />
</template>

<script>
import Button from 'primevue/button'

export default {
    name: 'CoreButton',

    components: { Button },

    props: {
        label: {
            type: String,
            default: '',
        },

        labelParams: {
            type: Object,
            default: () => ({}),
        },

        icon: {
            type: String,
            default: null,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        colorPrimary: {
            type: Boolean,
            default: false,
        },

        floatRight: {
            type: Boolean,
            default: false,
        },

        variant: {
            type: String,
            default: 'primary',
            validator: (v) => ['primary', 'secondary', 'tertiary', 'danger'].includes(v),
        },
    },

    computed: {
        classes() {
            return {
                'core-button': true,
                'core-button--disabled': this.disabled,
                'core-button--float-right': this.floatRight,
                [`core-button--${this.variant}`]: true,
            }
        },

        getLabel() {
            return this.$t(this.label, this.labelParams)
        },

        iconName() {
            return `pi ${this.icon}`
        },
    },
}
</script>

<style>
.core-button.core-button {
    border-radius: 50px;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 1.2rem 2.2rem;
    color: var(--text-dark);

    &:hover,
    &:focus,
    &:active {
        color: var(--text-dark) !important;
        text-decoration: none;
    }

    &.core-button--primary {
        border: 1px solid var(--color-primary-600);
        outline: 1px solid var(--color-primary-100);
        background: var(--color-primary-100);
    }

    &.core-button--primary:hover,
    &.core-button--primary:focus,
    &.core-button--primary:active {
        border: 1px solid var(--color-primary-600);
        outline: 1px solid var(--color-primary-400);
        background: var(--color-primary-600);
    }

    &.core-button--secondary {
        border: 1px solid var(--color-secondary-600);
        outline: 1px solid var(--color-secondary-100);
        background: var(--color-primary-100);
    }

    &.core-button--secondary:hover,
    &.core-button--secondary:focus,
    &.core-button--secondary:active {
        border: 1px solid var(--color-secondary-600);
        outline: 1px solid var(--color-secondary-400);
        background: var(--color-primary-300);
    }

    &.core-button--tertiary {
        border: 1px solid var(--color-neutral-800);
        outline: 1px solid var(--color-neutral-100);
        background: var(--color-neutral-100);
    }

    &.core-button--tertiary:hover,
    &.core-button--tertiary:focus,
    &.core-button--tertiary:active {
        border: 1px solid var(--color-neutral-900);
        outline: 1px solid var(--color-neutral-700);
        background: var(--color-neutral-500);
    }

    &.core-button--danger {
        border: 1px solid var(--color-error);
        outline: 1px solid var(--color-red-100);
        background: var(--color-red-100);
    }

    &.core-button--danger:hover,
    &.core-button--danger:focus,
    &.core-button--danger:active {
        border: 1px solid var(--color-error);
        outline: 1px solid var(--color-red-300);
        background: var(--color-red-300);
    }

    &.core-button--disabled {
        border: 1px solid var(--color-disabled);
        outline: 1px solid var(--color-neutral-100);
        background: var(--color-disabled-bg);
    }

    &.core-button--disabled:hover,
    &.core-button--disabled:focus,
    &.core-button--disabled:active {
        border: 1px solid var(--color-disabled);
        outline: 1px solid var(--color-neutral-100);
        background: var(--color-disabled-bg);
    }
}
</style>
